import { Observable } from "rxjs";

import { AuthUser } from "./model/user-auth.model";

import * as AuthActions from "./auth.actions";

import { PayloadAction } from "./../shared/model/action.model";

export type AuthState = AuthUser;

function getInitialState() {
  return localStorage.getItem("loggedIn")
    ? new AuthUser("321123", "Steven Miller")
    : new AuthUser(null, "Guest");
}

export default function(state = getInitialState(), action: AuthActions.All) {
  switch (action.type) {
    case AuthActions.LOGIN: {
      return { ...state, loading: true };
    }
    case AuthActions.LOGIN_SUCCESS: {
      return { ...state, ...action.payload, loading: false };
    }
    case AuthActions.LOGIN_ERROR: {
      return { ...state, ...action.payload, loading: false };
    }
    case AuthActions.LOGOUT: {
      return getInitialState();
    }
    default: {
      return state;
    }
  }
}
